import React from 'react';
import { AvatarProps } from './types';
import {
  StyledAvatar,
  StyledAvatarImage,
  StyledAvatarPlaceholder,
  StyledAvatarPlaceholderText,
} from './styles';
import { AvatarSize } from './enums';

const getInitials = (name?: string): string => {
  if (!name) return '';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const Avatar: React.FC<AvatarProps> = ({
  size = AvatarSize.Small,
  src,
  alt,
  noBorder,
  placeholder,
}) => {
  const initials = getInitials(alt);
  return (
    <StyledAvatar {...{ size, noBorder }}>
      {src ? (
        <StyledAvatarImage {...{ src, alt }} />
      ) : (
        <>
          {placeholder || (
            <StyledAvatarPlaceholder>
              <StyledAvatarPlaceholderText {...{ size }}>
                {initials || '·'}
              </StyledAvatarPlaceholderText>
            </StyledAvatarPlaceholder>
          )}
        </>
      )}
    </StyledAvatar>
  );
};

export default Avatar;
